// src/common/components/settingsForm/SettingsForm.tsx (веб)

import React from 'react'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { SettingsFormItem } from '../../../../../common/types/interfaces'
import add from '../../../../../assets/images/icons/add.svg'
import sort from '../../../../../assets/images/icons/swap.svg'
import close from '../../../../../assets/images/icons/close.svg'
import { useSettingsForm } from './useSettingsForm'
import classes from './SettingsForm.module.sass'
import { maxClusterSettingsCount } from '../../../../../common/utils/constants'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'

type Props<T, K extends keyof T> = {
  data: T[K] extends SettingsFormItem[] ? T[K] : never
  setData: React.Dispatch<React.SetStateAction<T>>
  fieldName: K
  placeHolders: string[]
  setDisabled: React.Dispatch<React.SetStateAction<boolean>>
}

export const SettingsForm = <T, K extends keyof T>({
  data,
  setData,
  fieldName,
  placeHolders,
  setDisabled,
}: Props<T, K>) => {
  const { addItem, handleInputChange, sortItems, removeItem } = useSettingsForm(
    setData,
    fieldName,
    setDisabled,
    data,
  )

  const darkTheme = useSelector(selectDarkTheme)
  const isDelivery = fieldName === 'delivery'

  return (
    <div className={classes.container}>
      {/* Шапка */}
      <div className={classes.header}>
        <div className={classes.headerCell}>{placeHolders[0]}</div>
        <div className={classes.headerCell}>{placeHolders[1]}</div>
        {isDelivery && (
          <>
            <div className={classes.headerCell}>Исполнителю</div>
            <div className={classes.headerCell}>Радиус, м</div>
            <div className={classes.headerCell}>Тег</div>
          </>
        )}
        <div className={classes.headerCell}></div>
      </div>

      {data &&
        data.map((el) => (
          <div className={classes.item} key={el.id}>
            {/* level — красная рамка только для бонусов */}
            <input
              onChange={(e) => handleInputChange(el.id, e.target.value, 'level')}
              style={{
                borderColor: !isDelivery && !el?.level && el.level !== 0 ? 'red' : '',
              }}
              type="text"
              className={darkTheme ? classes.inputDark : classes.input}
              value={el.level}
              placeholder={placeHolders[0]}
            />

            {/* value — красная рамка всегда */}
            <input
              onChange={(e) => handleInputChange(el.id, e.target.value, 'value')}
              style={{ borderColor: el?.value || el.value === 0 ? '' : 'red' }}
              type="text"
              className={darkTheme ? classes.inputDark : classes.input}
              value={el.value}
              placeholder={placeHolders[1]}
            />

            {isDelivery && (
              <>
                {/* fee — без рамки */}
                <input
                  onChange={(e) => handleInputChange(el.id, e.target.value, 'fee')}
                  type="text"
                  className={darkTheme ? classes.inputDark : classes.input}
                  value={el.fee || ''}
                  placeholder="Оплата исполнителю, руб"
                />
                {/* radius — без рамки */}
                <input
                  onChange={(e) => handleInputChange(el.id, e.target.value, 'radius')}
                  type="text"
                  className={darkTheme ? classes.inputDark : classes.input}
                  value={el.radius || ''}
                  placeholder="Радиус, м"
                />
                {/* tag — текстовый, без цифровой фильтрации */}
                <input
                  onChange={(e) => handleInputChange(el.id, e.target.value, 'tag')}
                  type="text"
                  className={darkTheme ? classes.inputDark : classes.input}
                  value={el.tag || ''}
                  placeholder="Тег (центр, север...)"
                />
              </>
            )}

            <IconButton
              small
              icon={close}
              display={data && data.length > 0}
              alt="Удалить"
              onClick={() => removeItem(el.id)}
            />
          </div>
        ))}

      <div className={classes.buttons}>
        <IconButton
          icon={sort}
          alt="Сортировать"
          onClick={sortItems}
          display={data && data.length > 1}
        />
        <IconButton
          icon={add}
          display={!data || data.length < maxClusterSettingsCount}
          alt="Добавить"
          onClick={addItem}
        />
      </div>
    </div>
  )
}